define('businessServices/authentication/sessionWorkflowFlags',['businessServices/authentication/stores/sessionWorkflowFlagsStore'
], function(sessionWorkflowFlagsStore) {
    const _workflowItems = {
        hasBypassedPastDueBalance : null,
        hasBypassedMiscProblems : null,
        hasBypassedClosedAccount : null,
        onboardingSpecialistRequested: null,
        isSchedulingAfterOnboardingWizard: null
    };
    let originalPathname = null;

    const receiveAlertLoginSuccessful = (loginInfo) => {
        sessionWorkflowFlagsStore.setStoreForLoginType(loginInfo.loginType);
        const existingFlagInfo = sessionWorkflowFlagsStore.getValue();

        if (existingFlagInfo) {
            _workflowItems.hasBypassedMiscProblems = existingFlagInfo.hasBypassedMiscProblems;
            _workflowItems.hasBypassedPastDueBalance = existingFlagInfo.hasBypassedPastDueBalance;
            _workflowItems.hasBypassedClosedAccount = existingFlagInfo.hasBypassedClosedAccount;
            _workflowItems.onboardingSpecialistRequested = existingFlagInfo.onboardingSpecialistRequested;
            _workflowItems.isSchedulingAfterOnboardingWizard = existingFlagInfo.isSchedulingAfterOnboardingWizard === true;
        } else {
            _workflowItems.hasBypassedMiscProblems = false;
            _workflowItems.hasBypassedPastDueBalance = false;
            _workflowItems.hasBypassedClosedAccount = false;
            _workflowItems.onboardingSpecialistRequested = false;
            _workflowItems.isSchedulingAfterOnboardingWizard = false;
        }
    };

    const save = () => {
        sessionWorkflowFlagsStore.saveValue(_workflowItems);
    };

    const receiveAlertLogout = () => {
        _workflowItems.hasBypassedPastDueBalance = null;
        _workflowItems.hasBypassedMiscProblems = null;
        _workflowItems.hasBypassedClosedAccount = null;
        _workflowItems.onboardingSpecialistRequested = null;
        _workflowItems.isSchedulingAfterOnboardingWizard = null;
        sessionWorkflowFlagsStore.deleteValue();
    };

    const hasBypassedPastDueBalance = (setValue)  => {
        if (setValue === undefined) {
            return _workflowItems.hasBypassedPastDueBalance;
        } else {
            _workflowItems.hasBypassedPastDueBalance = setValue;
            save();
        }
    };

    const hasBypassedMiscProblems = (setValue)  => {
        if (setValue === undefined) {
            return _workflowItems.hasBypassedMiscProblems;
        } else {
            _workflowItems.hasBypassedMiscProblems = setValue;
            save();
        }
    };

    const hasBypassedClosedAccount = (setValue)  => {
        if (setValue === undefined) {
            return _workflowItems.hasBypassedClosedAccount;
        } else {
            _workflowItems.hasBypassedClosedAccount = setValue;
            save();
        }
    };

    const onboardingSpecialistRequested = (setValue)  => {
        if (setValue === undefined) {
            return _workflowItems.onboardingSpecialistRequested;
        } else {
            _workflowItems.onboardingSpecialistRequested = setValue;
            save();
        }
    };

    const isSchedulingAfterOnboardingWizard = (setValue)  => {
        if (setValue === undefined) {
            return _workflowItems.isSchedulingAfterOnboardingWizard;
        } else {
            _workflowItems.isSchedulingAfterOnboardingWizard = setValue;
            save();
        }
    };

    const getOriginalPathname = () => {
        return originalPathname;
    };

    const setOriginalPathname = (pathname) => {
        originalPathname = pathname;
    };

    return {
        hasBypassedMiscProblems : hasBypassedMiscProblems,
        hasBypassedPastDueBalance : hasBypassedPastDueBalance,
        hasBypassedClosedAccount : hasBypassedClosedAccount,
        onboardingSpecialistRequested : onboardingSpecialistRequested,
        isSchedulingAfterOnboardingWizard : isSchedulingAfterOnboardingWizard,
        getOriginalPathname: getOriginalPathname,
        setOriginalPathname: setOriginalPathname,

        alerts : {
            receiveAlertLoginSuccessful : receiveAlertLoginSuccessful,
            receiveAlertLogout : receiveAlertLogout
        }
    };
});

